import { render, staticRenderFns } from "./BlockCompany.vue?vue&type=template&id=06050a8a&scoped=true&"
import script from "./BlockCompany.vue?vue&type=script&lang=js&"
export * from "./BlockCompany.vue?vue&type=script&lang=js&"
import style0 from "./BlockCompany.vue?vue&type=style&index=0&id=06050a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06050a8a",
  null
  
)

export default component.exports